import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { MapPin, List, Heart, RefreshCw, Mail, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const helpfulLinks = [
  {
    to: "/",
    icon: MapPin,
    title: "Mapa schronisk",
    description: "Znajdź schronisko na interaktywnej mapie Polski",
  },
  {
    to: "/schroniska",
    icon: List,
    title: "Lista schronisk",
    description: "Przeglądaj schroniska według miast i województw",
  },
  {
    to: "/dla-schronisk",
    icon: Heart,
    title: "Dla schronisk",
    description: "Dowiedz się, jak dołączyć i co zyskujesz",
  },
  {
    to: "/aktualizuj",
    icon: RefreshCw,
    title: "Aktualizuj dane",
    description: "Pomóż utrzymać aktualne informacje o schronisku",
  },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background px-4 py-12 sm:py-20">
      <Helmet>
        <title>Strona nieznaleziona - GdzieSchronisko</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="mx-auto max-w-2xl">
        <div className="text-center">
          <p className="text-7xl font-bold text-primary sm:text-8xl">404</p>
          <h1 className="mt-4 text-2xl font-bold text-foreground sm:text-3xl">
            Hmm, tej strony nie znaleźliśmy
          </h1>
          <p className="mt-3 text-muted-foreground">
            Strona mogła zostać przeniesiona lub usunięta. Spokojnie - mamy mnóstwo
            schronisk, które czekają na Twoją pomoc.
          </p>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Wróć do mapy
              </Link>
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="w-full sm:w-auto"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Poprzednia strona
            </Button>
          </div>
        </div>

        <div className="mt-12">
          <h2 className="mb-4 text-center text-sm font-semibold uppercase tracking-wide text-muted-foreground">
            Może szukasz czegoś z tej listy
          </h2>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {helpfulLinks.map(({ to, icon: Icon, title, description }) => (
              <Link
                key={to}
                to={to}
                className="group flex items-start gap-3 rounded-2xl border border-border bg-card p-4 transition-all hover:border-primary/40 hover:shadow-md"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="text-left">
                  <p className="font-semibold text-foreground">{title}</p>
                  <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
                </div>
              </Link>
            ))}
          </div>

          <p className="mt-8 text-center text-sm text-muted-foreground">
            Coś nie działa?{" "}
            <a
              href="mailto:kontakt@gdzieschronisko.pl"
              className="inline-flex items-center gap-1 font-medium text-primary underline-offset-4 hover:underline"
            >
              <Mail className="h-3.5 w-3.5" />
              Napisz do nas
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
